import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
// import Logo from 'assets/images/logo.png';
import Logo from 'assets/images/logo-white1.svg';
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

function LogoSection() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <ButtonBase
            disableRipple
            component={Link}
            to="/dashboard"
            className="logo-container"
            onClick={() => dispatch({ type: MENU_OPEN, id: 'dashboard' })}
        >
            <img src={Logo} alt="diolog-logo" />
        </ButtonBase>
    );
}

export default LogoSection;
